export default __webpack_public_path__ + "static/media/css.34cff660.png";